export default __webpack_public_path__ + "static/media/galleryImage3.7d7c6bcd.jpg";